export default "__VITE_ASSET__DwDQ9hv6__"